export default __webpack_public_path__ + "static/media/1.8587b155.png";